import * as MaterialUi from "@mui/material";
import * as React from "react";
import { FunctionComponent, MouseEvent, ReactNode, useState } from "react";

interface IconButtonProps {
    isDevice?: boolean;
    icon: ReactNode;
    isDisabled?: boolean;
    testId?: string;
    isProhibited?: boolean;
    onClick(event?: MouseEvent): void;
    size?: "small" | "medium";
    title?: string;
    className?: string;
}

const IconButton: FunctionComponent<IconButtonProps> = ({ icon, isDisabled, onClick, size, isProhibited, title, className, isDevice, testId }) => {
    const [showProhibitedMessage, setShowProhibitedMessage] = useState(false);

    return (
        <>
            <span title={isProhibited ? "This action is prohibited" : undefined}>
                <MaterialUi.IconButton
                    disabled={isDisabled}
                    onClick={event => {
                        if (isProhibited) {
                            setShowProhibitedMessage(true);
                            return;
                        }
                        onClick(event);
                    }}
                    size={size}
                    title={title}
                    className={className}
                    style={{ color: isDevice ? "#fff" : "", opacity: isProhibited ? 0.5 : undefined, cursor: isProhibited ? "not-allowed" : undefined }}
                    data-testid={testId}
                >
                    {icon}
                </MaterialUi.IconButton>
            </span>
            <MaterialUi.Snackbar
                open={showProhibitedMessage}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                onClose={() => setShowProhibitedMessage(false)}
            >
                <MaterialUi.Alert severity="warning" onClose={() => setShowProhibitedMessage(false)}>
                    You don&apos;t have permissions to perform this action.
                </MaterialUi.Alert>
            </MaterialUi.Snackbar>
        </>
    );
};

export default IconButton;
